import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UsersComponent } from './pages/users/users.component';
import { MaterialModule } from '../../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormUserComponent } from './components/form-user/form-user.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AccessControlRoutingModule } from './access-control.routes';
import { PermissionsComponent } from './pages/permissions/permissions.component';
import { PermissionsTableComponent } from './components/permissions-table/permissions-table.component';
import { ManagePermissionsComponent } from './components/manage-permissions/manage-permissions.component';

const accessControlComponents = [UsersComponent, PermissionsComponent];

const thirdComponents = [FormUserComponent, PermissionsTableComponent];
@NgModule({
  declarations: [accessControlComponents, thirdComponents, ManagePermissionsComponent],
  imports: [
    SharedModule,
    FormsModule,
    MaterialModule,
    AccessControlRoutingModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
  ],
  providers: [],
})
export class AccessControlModule {}
